import React from 'react'
import { createSelectable } from 'react-selectable-fast-control'
import musicianImg from '~/assets/musician.jpg'
import photographerImg from '~/assets/photographer.jpg'
import { TRANSITIONS } from '~/enums'
import * as PT from '~/PropTypes'
import ListItem from '../BaseAssetsListItem'
import './ListItem.scss'

export function getTransitionItem(type) {
  switch (type) {
    case TRANSITIONS.BLUR:
      return <BlurTransitionItem />
    case TRANSITIONS.DISSOLVE:
      return <DissolveTransitionItem />
    case TRANSITIONS.DIP_WHITE:
    case TRANSITIONS.DIP_BLACK:
      return <DipTransitionItem type={type} />
    case TRANSITIONS.FADEIN:
      return <FadeInTransitionItem />
    case TRANSITIONS.FADEOUT:
      return <FadeOutTransitionItem />
    case TRANSITIONS.WIPE_RIGHT:
      return <WipeRightTransitionItem />
    case TRANSITIONS.WIPE_LEFT:
      return <WipeLeftTransitionItem />
    case TRANSITIONS.WIPE_UP:
      return <WipeUpTransitionItem />
    case TRANSITIONS.WIPE_DOWN:
      return <WipeDownTransitionItem />
    default:
      throw new Error(`Transition ${type} is not implemented`)
  }
}

/**
 *
 * @param {{ asset: Assets.TransitionAsset, [x:string]: any }} props
 * @returns
 */
function TransitionAssetsListItem({ asset, ...rest }) {
  return (
    <ListItem
      {...rest}
      composeDragItem={item => ({ transitionType: item.type })}
      className="transition-asset"
      asset={asset}
    >
      <div className="transition-asset__item">
        {getTransitionItem(asset.type)}
      </div>
    </ListItem>
  )
}

TransitionAssetsListItem.propTypes = {
  asset: PT.TransitionAsset.isRequired,
}

export default createSelectable(TransitionAssetsListItem)

function BlurTransitionItem() {
  return (
    <div className="transition-asset__box transition-asset__box--blur">
      <img src={photographerImg} alt="" />
      <img src={musicianImg} alt="" />
    </div>
  )
}

function DissolveTransitionItem() {
  return (
    <div className="transition-asset__box transition-asset__box--dissolve">
      <img src={photographerImg} alt="" />
      <img src={musicianImg} alt="" />
    </div>
  )
}

function DipTransitionItem({ type }) {
  return (
    <div
      className="transition-asset__box transition-asset__box--dip"
      style={{ backgroundColor: type === TRANSITIONS.DIP_WHITE ? 'white' : 'black' }}
    >
      <img src={photographerImg} alt="" />
      <img src={musicianImg} alt="" />
    </div>
  )
}

function FadeInTransitionItem() {
  return (
    <div className="transition-asset__box transition-asset__box--fade-in">
      <img src={musicianImg} alt="" />
    </div>
  )
}

function FadeOutTransitionItem() {
  return (
    <div className="transition-asset__box transition-asset__box--fade-out">
      <img src={photographerImg} alt="" />
    </div>
  )
}

function WipeRightTransitionItem() {
  return (
    <div className="transition-asset__box transition-asset__box--wipe--right">
      <img src={photographerImg} alt="" />
      <img src={musicianImg} alt="" />
    </div>
  )
}

function WipeLeftTransitionItem() {
  return (
    <div className="transition-asset__box transition-asset__box--wipe--left">
      <img src={photographerImg} alt="" />
      <img src={musicianImg} alt="" />
    </div>
  )
}

function WipeUpTransitionItem() {
  return (
    <div className="transition-asset__box transition-asset__box--wipe--up">
      <img src={photographerImg} alt="" />
      <img src={musicianImg} alt="" />
    </div>
  )
}

function WipeDownTransitionItem() {
  return (
    <div className="transition-asset__box transition-asset__box--wipe--down">
      <img src={photographerImg} alt="" />
      <img src={musicianImg} alt="" />
    </div>
  )
}
